const confirmEmail = 'CONFIRM_EMAIL';
const choosePassword = 'CHOOSE_PASSWORD';

export default {
  confirmEmail,
  choosePassword,
};
